export const StateDetails = (() => {
	'use strict';

	function init() {

		expanderToggle();

		if ( !$('body').hasClass('wp-admin') ) {

			$('.state-details__slider').slick({
				dots: true,
				arrows: true,
				
				centerMode: false,
				speed: 200,
				autoplay: false,
				autoplaySpeed: 0,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
					  dots: false
					  }
					}
					
				
				  ]
			});
	
			}

			
	}

	function expanderToggle() {

		var $toggle = $('.state-expander__toggle .toggle');
		var $expander = $('.state-expander__drawer');

		

		$expander.hide();

		$toggle.on('click', function(event) {

			$(this).toggleClass('clicked');
			
			$expander.slideToggle();
			
			
			
			
		});


	}

	

	return {
		init: init,
		name: 'state-details'
	};
})();
